import { createAction } from 'redux-actions';

export const getTransactions =
  createAction('GET_TRANSACTIONS', (payload) => payload, (payload, meta) => meta);
export const getTransactionsSuccess =
  createAction('GET_TRANSACTIONS_SUCCESS', (payload) => payload, (payload, meta) => meta);
export const getTransactionsFailure =
  createAction('GET_TRANSACTIONS_FAILURE', (payload) => payload, (payload, meta) => meta);

export const createTransactions =
  createAction('CREATE_TRANSACTIONS', (payload) => payload, (payload, meta) => meta);
export const createTransactionsSuccess =
  createAction('CREATE_TRANSACTIONS_SUCCESS', (payload) => payload, (payload, meta) => meta);
export const createTransactionsSuccessOptimistic =
  createAction('CREATE_TRANSACTIONS_SUCCESS_OPTIMISTIC', (payload) => payload, (payload, meta) => meta);
export const createTransactionsFailure =
  createAction('CREATE_TRANSACTIONS_FAILURE', (payload) => payload, (payload, meta) => meta);

// Batch updates
export const updateTransactions =
  createAction('UPDATE_TRANSACTIONS', (payload) => payload, (payload, meta) => meta);
export const updateTransactionsSuccess =
  createAction('UPDATE_TRANSACTIONS_SUCCESS', (payload) => payload, (payload, meta) => meta);
export const updateTransactionsSuccessOptimistic =
  createAction('UPDATE_TRANSACTIONS_SUCCESS_OPTIMISTIC', (payload) => payload, (payload, meta) => meta);
export const updateTransactionsFailure =
  createAction('UPDATE_TRANSACTIONS_FAILURE', (payload) => payload, (payload, meta) => meta);

export const deleteTransactions =
  createAction('DELETE_TRANSACTIONS', (payload) => payload, (payload, meta) => meta);
export const deleteTransactionsSuccess =
  createAction('DELETE_TRANSACTIONS_SUCCESS', (payload) => payload, (payload, meta) => meta);
export const deleteTransactionsSuccessOptimistic =
  createAction('DELETE_TRANSACTIONS_SUCCESS_OPTIMISTIC', (payload) => payload, (payload, meta) => meta);
export const deleteTransactionsFailure =
  createAction('DELETE_TRANSACTIONS_FAILURE', (payload) => payload, (payload, meta) => meta);

// Special action to adjust transactions after a GET
export const autoCategorizeTransactions =
  createAction('AUTO_CATEGORIZE_TRANSACTIONS', (payload) => payload, (payload, meta) => meta);

export const clearLastReduction =
  createAction('CLEAR_LAST_REDUCTION', (payload) => payload, (payload, meta) => meta);

// Special action to adjust transactions after a GET
export const updateTransactionCategoriesForPayeeAction =
  createAction('UPDATE_TRANSACTION_CATEGORIES_FOR_PAYEE_ACTION', (payload) => payload, (payload, meta) => meta);


// ACTION API
export const performTransactionAction =
  createAction('PERFORM_TRANSACTION_ACTION', (payload) => payload, (payload, meta) => meta);
export const performTransactionActionSuccess =
  createAction('PERFORM_TRANSACTION_ACTION_SUCCESS', (payload) => payload, (payload, meta) => meta);
export const performTransactionActionFailure =
  createAction('PERFORM_TRANSACTION_ACTION_FAILURE', (payload) => payload, (payload, meta) => meta);

// Create opening balance from the given account
export const createOpeningBalanceTransactionAction =
  createAction('CREATE_OPENING_BALANCE_ACTION', (payload) => payload, (payload, meta) => meta);
